import { render, staticRenderFns } from "./addVolunteerPreliminary.vue?vue&type=template&id=2d3d16e1&scoped=true"
import script from "./addVolunteerPreliminary.vue?vue&type=script&lang=js"
export * from "./addVolunteerPreliminary.vue?vue&type=script&lang=js"
import style0 from "./addVolunteerPreliminary.vue?vue&type=style&index=0&id=2d3d16e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d16e1",
  null
  
)

export default component.exports